module.exports = __webpack_public_path__ + "static/media/ice.66851ff5.png";